import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Chapters from './toc/chapters.jsx';
import Bookmarks from './toc/bookmarks.jsx';
import { KEYS } from 'const';

import classnames from 'classnames';

const tabList = ['Chapters', 'Bookmarks'];

export default class TocMenu extends PureComponent {
    static displayName = 'TocMenu';

    static propTypes = {
        chapters: PropTypes.array,
        content: PropTypes.any.isRequired,
        open: PropTypes.bool,
        pagenum: PropTypes.number,
        closeMenu: PropTypes.func.isRequired,
    };

    state = {
        currentTab: 'Chapters',
    };

    tocRef = React.createRef();

    componentDidMount() {
        this.tocRef.current.addEventListener('keyup', this.onKeyUp);
    }

    componentWillUnmount() {
        this.tocRef.current.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp = e => {
        e.stopPropagation();
        if ([KEYS.LEFT, KEYS.RIGHT].includes(e.which)) {
            this.selectTab(
                tabList.find(tab => tab !== this.state.currentTab),
                e
            );
            this.tocRef.current.querySelector('.active').focus();
        }
    };

    selectTab = (currentTab, event) => {
        event.preventDefault();
        if (this.state.currentTab !== currentTab) {
            this.setState({ currentTab });
        }
    };

    renderTabs(open) {
        const { chapters } = this.props;
        const { currentTab } = this.state;

        return tabList.map((name, index) => {
            return (
                <li key={name} aria-selected={name === currentTab} role="tab">
                    <button
                        onClick={e => this.selectTab(name, e)}
                        className={classnames(
                            { active: name === currentTab },
                            'tab'
                        )}
                        aria-controls="aria-navigation-panel-chapters"
                        tabIndex={index ? chapters.length + 1 : null}
                    >
                        {name}
                    </button>
                </li>
            );
        });
    }

    renderContent(open) {
        const { content, pagenum } = this.props;
        switch (this.state.currentTab) {
            case 'Chapters':
                return (
                    <Chapters
                        open={open}
                        pagenum={pagenum}
                        content={content}
                        chapters={this.props.chapters}
                        closeMenu={this.props.closeMenu}
                    />
                );
            case 'Bookmarks':
                return (
                    <Bookmarks
                        open={open}
                        content={content}
                        closeMenu={this.props.closeMenu}
                    />
                );
        }
    }

    render() {
        const { open } = this.props;

        return (
            <div ref={this.tocRef}>
                <ul className="tabs clearfix" role="tablist">
                    {this.renderTabs(open)}
                </ul>
                <div className="tab-content" aria-live="polite">
                    {this.renderContent(open)}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/engage_reader/navbar/toc_menu.jsx